<template>
  <div class="moduleCard">
    <div class="row">
      <div class="col-6">
        <h1 id="select_members_or_groups">{{title}}</h1>
      </div>
      <div class="col-6 text-right">
        <a href="javascript:void(0)" @click="goBack" v-show="backbutton===true"><font-awesome-icon icon="arrow-left" role="presentation" </font-awesome-icon><span id="go_back">Go Back</span></a>
      </div>
    </div>

    <div class="row" v-show="mode==='0'">
      <div class="col-6">
        <button class="btn btn-secondary mr-3 ib btn-short"  @click="switchToUsers" id="members">Members</button>
        <button class="btn btn-secondary ib btn-short"  @click="switchToGroups" id="groups">Groups</button>
      </div>

    </div>

    <div class="row mt-4" v-show="selectedMode==='0'">
      <div class="col-5">
        <div class="row mt-2">
          <div class="col-6">
            <h3 id="available_members">Available Members</h3>
          </div>
          <div class="col-6 text-right">
            <button class="btn-std" @click="doLeftSelectAll" name="select_all">Select All</button>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-12">
            <span name="search">Search</span>: <input type="text" class="fullWidth" v-model="leftSearch" @keyup="doLeftSearch" />
          </div>
        </div>

        <div class="mt-2 scroll">
          <select multiple="true" id="selectFrom" class="mSelect">
            <option v-for="i of showUsers" v-bind:value="i.value" @dblclick="doItemSelect">
              {{i.name}}
            </option>
          </select>
        </div>
        <div class="mt-2 highlight-text" id="ctr_click">
           Tip: Double click to automatically select one item.<br />Use ctrl+click to highlight desired items and then click the green arrow to select.
        </div>
      </div>
      <div class="col-2 midcolumn text-center">
        <div>
          <button class="btn-transparent" @click="doItemSelect">
            <img src="@/assets/images/scriptingScrollRight.png" alt="Select" />
          </button>
        </div>
        <div class="mt-5">
          <button class="btn-transparent" @click="doItemDeselect">
            <img src="@/assets/images/scriptingScrollLeft.png" alt="Deselect" />
          </button>
        </div>
      </div>
      <div class="col-5">
        <div class="row mt-2">
          <div class="col-6">
            <h3 id="selected_members">Selected Members</h3>
          </div>
          <div class="col-6 text-right">
            <button class="btn-std" @click="doRightSelectAll" name="select_all">Select All</button>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <span name="search">Search</span>: <input type="text" class="fullWidth" v-model="rightSearch" @keyup="doRightSearch" />
          </div>

        </div>
        <div class="mt-2 scroll">
          <select multiple="true" id="selectTo" class="mSelect">
            <option v-for="i of showSelectedUsers" v-bind:value="i.value">
              {{i.name}}
            </option>
          </select>
        </div>
      </div>

    </div>
    <div class="row mt-4" v-show="selectedMode==='1'">
      <div class="col-5">
        <div class="row mt-2">
          <div class="col-6">
            <h3 id="available_groups">Available Groups</h3>
          </div>
          <div class="col-6 text-right">
            <button class="btn-std" @click="groupDoLeftSelectAll" name="select_all">Select All</button>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-12">
            <span name="search">Search:</span> <input type="text" class="fullWidth" v-model="groupLeftSearch" @keyup="groupDoLeftSearch" />
          </div>
        </div>

        <div class="mt-2">
          <select multiple="true" id="groupSelectFrom" class="mSelect">
            <option v-for="i of showGroups" v-bind:value="i.value" @dblclick="groupDoItemSelect">
              {{i.name}}
            </option>
          </select>
        </div>
      </div>
      <div class="col-2 midcolumn text-center">
        <div>
          <button class="btn-transparent" @click="groupDoItemSelect">
            <img src="@/assets/images/scriptingScrollRight.png" alt="Select" />
          </button>
        </div>
        <div class="mt-5">
          <button class="btn-transparent" @click="groupDoItemDeselect">
            <img src="@/assets/images/scriptingScrollLeft.png" alt="Deselect" />
          </button>
        </div>
      </div>
      <div class="col-5">
        <div class="row">
          <div class="col-6">
            <h3 id="selected_groups">Selected Groups</h3>
          </div>
          <div class="col-6 text-right">
            <button class="btn-std" @click="groupDoRightSelectAll" name="select_all">Select All</button>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <span name="search">Search:</span> <input type="text" class="fullWidth" v-model="groupRightSearch" @keyup="groupDoRightSearch" />
          </div>

        </div>
        <div class="mt-2">
          <select multiple="true" id="groupSelectTo" class="mSelect">
            <option v-for="i of showSelectedGroups" v-bind:value="i.value">
              {{i.name}}
            </option>
          </select>
        </div>
      </div>

    </div>

    <div class="row mt-2">
      <div class="col-12 text-right">
        <button class="btn btn-primary btn-short" @click="doSelect" name="select">Select</button>
      </div>
    </div>
  </div>
</template>


<script>
  export default {
    name: "SelectUsers",
    props:["mode","backbutton","notitle"],
    data() {
      return {
        leftSearch:"",
        rightSearch:"",
        groupLeftSearch:"",
        groupRightSearch:"",
        showUsers:[],
        userPool:[],
        selectedUsers:[],
        showSelectedUsers:[],
        showGroups:[],
        groupPool:[],
        selectedGroups:[],
        showSelectedGroups:[],
        selectedMode:null,
        title:""
      }
    },
    methods: {
      doItemDeselect() {
        var sOptions = Array.prototype.slice.call(document.querySelectorAll('#selectTo option:checked'),0).map(function(v,i,a) { 
          return v; 
        });
        for(var q=0; q<sOptions.length; q++) {
          var i = sOptions[q];
          var rid=-1;
          for (var x=0; x<this.selectedUsers.length; x++) {
            if (this.selectedUsers[x].value===i.value) {
              rid=x;
            }
          }
          if (rid>-1) {
            this.selectedUsers.splice(rid,1);
          }
        }
        this.rightSearch="";
        this.showSelectedUsers=this.selectedUsers;
        this.$forceUpdate();
      },
      doItemSelect() {
        var sOptions = Array.prototype.slice.call(document.querySelectorAll('#selectFrom option:checked'),0).map(function(v,i,a) { 
          return v; 
        });
        for(var x=0; x<sOptions.length; x++) {
          var i = sOptions[x];
          if (this.selectedUsers.filter(p=>p.value===i.value).length===0) {
            this.selectedUsers.push({name: i.text, value: i.value});
          }
        }
        this.rightSearch="";
        this.showSelectedUsers=this.selectedUsers;
        this.$forceUpdate();
      },
      doLeftSearch() {
        if (this.leftSearch.length>0) {
          this.showUsers=[];
          for(var u of this.userPool) {
            if (u.name.toLowerCase().indexOf(this.leftSearch.toLowerCase())>-1) {
              this.showUsers.push(u);
            }
          }
        }
        else {
          this.showUsers=this.userPool;
        }
        this.$forceUpdate();
      },
      doRightSearch() {
        if (this.rightSearch.length>0) {
          this.showSelectedUsers=[];
          for(var u of this.selectedUsers) {
            if (u.name.toLowerCase().indexOf(this.rightSearch.toLowerCase())>-1) {
              this.showSelectedUsers.push(u);
            }
          }
        }
        else {
          this.showSelectedUsers=this.selectedUsers;
        }
        this.$forceUpdate();
      },
      doLeftSelectAll() {
        for (var i = 0; i < document.getElementById("selectFrom").options.length; i++) { 
          document.getElementById("selectFrom").options[i].selected = true; 
        } 
      },
      doRightSelectAll() {
        for (var i = 0; i < document.getElementById("selectTo").options.length; i++) { 
          document.getElementById("selectTo").options[i].selected = true; 
        } 
      },
      doSelect() {
        if (this.selectedMode==='0') {
          if (this.selectedUsers.length>0) {
            this.$parent.usersSelected();
          }
          else {
            this.popDialog(1, "Error: No users selected");
          }
        }
        else {
          if (this.selectedGroups.length>0) {
            this.$parent.groupsSelected();
          }
          else {
            this.popDialog(1, "Error: No groups selected");
          }
        }
      },
      getData() {
        if (this.selectedMode==='0') {
          return this.selectedUsers;
        }
        else {
          return this.selectedGroups;
        }
      },
      goBack() {
        this.$parent.goBack();
      },
      groupDoItemDeselect() {
        var sOptions = Array.prototype.slice.call(document.querySelectorAll('#groupSelectTo option:checked'),0).map(function(v,i,a) { 
          return v; 
        });
        for(var q=0; q<sOptions.length; q++) {
          var i = sOptions[q];
          var rid=-1;
          for (var x=0; x<this.selectedGroups.length; x++) {
            if (this.selectedGroups[x].value===i.value) {
              rid=x;
            }
          }
          if (rid>-1) {
            this.selectedGroups.splice(rid,1);
          }
        }
        this.rightSearch="";
        this.showSelectedGroups=this.selectedGroups;
        this.$forceUpdate();
      },
      groupDoItemSelect() {
        var sOptions = Array.prototype.slice.call(document.querySelectorAll('#groupSelectFrom option:checked'),0).map(function(v,i,a) { 
          return v; 
        });
        for(var x=0; x<sOptions.length; x++) {
          var i = sOptions[x];
          if (this.selectedGroups.filter(p=>p.value===i.value).length===0) {
            this.selectedGroups.push({name: i.text, value: i.value});
          }
        }
        this.rightSearch="";
        this.showSelectedGroups=this.selectedGroups;
        this.$forceUpdate();
      },
      groupDoLeftSearch() {
        if (this.groupLeftSearch.length>0) {
          this.showGroups=[];
          for(var u of this.groupPool) {
            if (u.name.toLowerCase().indexOf(this.groupLeftSearch.toLowerCase())>-1) {
              this.showGroups.push(u);
            }
          }
        }
        else {
          this.showGroups=this.groupPool;
        }
        this.$forceUpdate();
      },
      groupDoRightSearch() {
        if (this.groupRightSearch.length>0) {
          this.showSelectedGroups=[];
          for(var u of this.selectedGroups) {
            if (u.name.toLowerCase().indexOf(this.groupRightSearch.toLowerCase())>-1) {
              this.showSelectedGroups.push(u);
            }
          }
        }
        else {
          this.showSelectedGroups=this.selectedGroups;
        }
        this.$forceUpdate();
      },
      groupDoLeftSelectAll() {
        for (var i = 0; i < document.getElementById("groupSelectFrom").options.length; i++) { 
          document.getElementById("groupSelectFrom").options[i].selected = true; 
        } 
      },
      groupDoRightSelectAll() {
        for (var i = 0; i < document.getElementById("groupSelectTo").options.length; i++) { 
          document.getElementById("groupSelectTo").options[i].selected = true; 
        } 
      },
      setData(_title, _presetUsers, _userPool, _presetGroups, _groupPool) {

        this.title=_title;
        this.userPool=[];
        this.selectedUsers=[];
        this.showSelectedUsers=[];
        this.showSelectedGroups=[];
        this.groupPool=[];
        this.selectedGroups=[];

        if (_userPool!==null) {
          for(var u of _userPool) {
            this.userPool.push({name: this.buildSimUser(u.ClientID,u.Username,u.EmailAddress,u.FirstName,u.LastName,false,false), value: u.ClientID})
          }

          this.showUsers=this.userPool;

          for(var u of _presetUsers) {
            this.selectedUsers.push({name: this.buildSimUser(u.ClientID,u.Username,u.EmailAddress,u.FirstName,u.LastName,false,false), value: u.ClientID});
          }

          this.showSelected=this.selectedUsers;
        }

        if (_groupPool!==null) {
          for(var g of _groupPool) {
            this.groupPool.push({name: this.decodeHtml(g.LicensePoolGroupName), value: g.LicensePoolGroupID});
          }

          this.showGroups=this.groupPool;

          for(var g of _presetGroups) {
            this.selectedGroups.push({name: this.decodeHtml(g.LicensePoolGroupName), value: g.LicensePoolGroupID});
          }

          this.showSelectedGroups=this.selectedGroups;
        }

        setTimeout(Window.loadLanguageContent(this.ttype), 5000);
      },
      switchToGroups() {
        this.selectedMode='1';
      },
      switchToUsers() {
        this.selectedMode='0';
      }
    },
    mounted() {
      if (this.mode==='0') {
        if (typeof(this.notitle)==="undefined" || this.notitle===null || this.notitle===false) {
          this.title='Select Users or Groups';
        }
        this.selectedMode='0';
      }
      else if (this.mode==='1') {
        if (typeof(this.notitle)==="undefined" || this.notitle===null || this.notitle===false) {
          this.title='Select Users';
        }
        this.selectedMode='0';
      }
      else {
        if (typeof(this.notitle)==="undefined" || this.notitle===null || this.notitle===false) {
          this.title='Select Groups';
        }
        this.selectedMode='1';
      }
    }
  }
</script>
